import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { useActifMemberCount } from "@domain/group/hooks";
import { PrimaryBold, PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { StudentIcon } from "@ui/components/icons";
import { InfoBulle } from "@ui/components/infoBulle";
import { row } from "@ui/components/layout";
import { TextSkeleton } from "@ui/components/skeleton/basicSkeletons";

interface ShareroomMembersCountProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const ShareroomMembersCount: React.FC<ShareroomMembersCountProps> = ({ shareroom, ...htmlProps }) => {
	const { result: membersCount } = useActifMemberCount(shareroom.id);
	return (
		<Container {...htmlProps}>
			<StyledInfoBulle text={I18n.t("shareroom.dashbaord.learners.information_bubble")} position="top" />
			<IconWrapper>
				<StudentIcon />
			</IconWrapper>
			<Bloc>
				{shareroom.license === "PREMIUM" ? (
					<PrimaryBold>{membersCount?.members ?? 0}</PrimaryBold>
				) : (
					<TextSkeleton height={10} />
				)}
				<PrimaryMedium>{I18n.t("shareroom.dashboard.general.learners.title")}</PrimaryMedium>
			</Bloc>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	position: relative;
	padding: 30px 44px;
	border: none;
	${row(8, undefined, "center")};
`;

const IconWrapper = styled.div`
	flex-shrink: 0;
	border-radius: 50%;
	width: 60px;
	height: 60px;
	background-color: ${({ theme }) => theme.colors.secondaryLight};
	${row(0, "center", "center")};
	> svg {
		width: 32px;
		height: 32px;
	}
`;
const Bloc = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 40px;
	gap: 12px;
`;
const StyledInfoBulle = styled(InfoBulle)`
	position: absolute;
	top: 5px;
	right: 3px;
`;
